/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const MegaphoneLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M9 17s7 1 10 4h1a1 1 0 0 0 1-1v-6.06a2 2 0 0 0 0-3.88V4a1 1 0 0 0-1-1h-1C16 6 9 7 9 7H5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h1l1 5h2zm2-8.34c.68-.15 1.53-.35 2.44-.62A20 20 0 0 0 19 5.57v12.86a20 20 0 0 0-5.56-2.47c-.91-.27-1.76-.47-2.44-.62zM5 9h4v6H5z" />
  </Icon>
);
